'use client'

import { useCallback } from 'react'

import { useOnboardingStore } from '@apps/onboarding/stores/onboarding.store'
import { ensureOnboardingComplete as ensureOnboardingCompleteThunk } from '@apps/onboarding/stores/onboarding.thunks'

export function useOnboardingFlow() {
  const { isOnboarding, currentStep, error } = useOnboardingStore()

  const ensureOnboardingComplete = useCallback(async () => {
    await ensureOnboardingCompleteThunk()
  }, [])

  return {
    error,
    currentStep,
    isOnboarding,
    ensureOnboardingComplete,
  }
}
